import { Icon, SVG } from './template';

export const Equal = Icon(({ width = 9, height = 4, ...props }, ref) => (
    <SVG {...props} width={width} height={height} ref={ref}>
        <path d="M0.5 0.5H8.5" stroke="currentColor" strokeLinecap="round" />
        <path d="M0.5 3H8.5" stroke="currentColor" strokeLinecap="round" />
    </SVG>
));
